import styled from 'styled-components';

import { theme } from './GlobalStyles';

const Spinner = styled.div`
  border: 5px solid ${theme.colors.purple};
  border-radius: 100%;
  width: 40px;
  height: 40px;
  margin: auto;
  border-right-color: transparent;
  animation: spin 1000ms linear infinite;

  @keyframes spin {
    from {
      transform: rotateZ(0deg);
    }
    to {
      transform: rotateZ(360deg);
    }
  }
`;

export default Spinner;
